if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.floadingcart();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        	document.querySelector('mini-cart').update();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }

    floadingcart(){
      if (typeof(jQuery('#product_variants').html()) != 'undefined') {
        var product_val = JSON.parse(jQuery('#product_variants').html());
         var current_id_variant = $('product-form input[name="id"]').val();
         var current_variant = '';
         $('.main-float-cart input').unbind();
         $('.main-float-cart input').change(function(){
            var arr = [];
            $('.main-float-cart input:checked').each(function(){
              arr.push($(this).val());
            });
            var variant = '';
            for (var i=0; i< product_val.length; i++) {
              if (JSON.stringify(product_val[i]['options']) === JSON.stringify(arr)) {
                variant = product_val[i];
              }
            }

            if (variant != '') {
              var regular_price = Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat);
              var sale_price = Shopify.formatMoney(variant.price, theme.moneyFormat);
              if (!variant.compare_at_price || variant.compare_at_price == variant.price) {
                $('.floading-addcart-price').html('<span class="price-item price-item--regular">'+sale_price+'</span>');
              } else {
                $('.floading-addcart-price').html('<span class="price-item price-item--regular old-price">'+regular_price+'</span><span class="price-item price-item--sale">'+sale_price+'</span>');
              }

              $(".main-float-cart").find('.price').attr('data-price', variant.price);
              updateCurrencies();
            }

            $(this).closest('.main-float-cart').find('input[name="id"]').val(variant.id);
            var bt = $(this).closest('.main-float-cart').find('button');
            if (variant.available) {
              bt.html(bt.data('available'));
              bt.removeAttr('disabled');
            } else {
              bt.html(bt.data('sold_out'));
              bt.attr('disabled', 'disabled');
            }
          }); 
      }

  	}

  });
}
